import React, { Component } from 'react'
import {connect} from 'react-redux'

class FullBrowserHeightFix extends Component {


  constructor(props){
    super();

    let realScreenHeight = window.screen.height;

    // iOs reports the screen heigh independetly of orientation
    if(this.isioOs()){
      if(window.innerWidth < window.innerHeight){
        realScreenHeight = window.screen.height;
      }else{
        realScreenHeight = window.screen.width;
      }
    }

    // Adjusts
    realScreenHeight-= 40;


      //console.log('h',window.screen.height,'w',window.screen.width );

    this.state = {
      isMobile : this.isMobile(),
      screenHeight : window.innerHeight,
      realScreenHeight,
      orientation : this.orientation()
    }

    //console.log(this.state);

    this.checkOrientation = this.checkOrientation.bind(this)

    props.setScreenHeight(this.state)


  }

  componentDidMount(){
    window.addEventListener('resize',this.checkOrientation)
    window.addEventListener('resize',this.checkOrientation)
  }

  checkOrientation(){

    console.log('resize');
    if(window.innerWidth < window.innerHeight && this.state.orientation === 'landscape'){
       let newState = {
         isMobile : this.isMobile(),
         screenHeight : window.innerHeight,
          realScreenHeight:  window.screen.height ,
         orientation : this.orientation()
       }


        this.setState(newState)
        console.log(" landscape > portrait",newState);

        this.props.setScreenHeight(newState)
    }
    if(window.innerWidth > window.innerHeight && this.state.orientation === 'portrait'){
      let newState = {
        isMobile : this.isMobile(),
        screenHeight : window.innerHeight,
        realScreenHeight: (this.isioOs())? window.screen.width -40 : window.screen.height - 40 ,
        orientation : this.orientation()
      }
       this.setState(newState)
       console.log("portrait > landscape",newState);

       this.props.setScreenHeight(newState)
    }


  }

  orientation(){
    if(window.innerWidth < window.innerHeight){
      return 'portrait'
    }else{
      return 'landscape'
    }
  }

  isMobile() {
     var userAgent = navigator.userAgent || navigator.vendor || window.opera;

         // Windows Phone must come first because its UA also contains "Android"
       if (/windows phone/i.test(userAgent)) {
           return true
       }

       if (/android/i.test(userAgent)) {
           return true
       }

       // iOS detection from: http://stackoverflow.com/a/9039885/177710
       if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
           return true
       }

       return false
   }

  isioOs(){
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return true
      }
  }

  render() {

    let style_obj = {}

      if(this.state.isMobile){
         style_obj = {
           minHeight: this.state.screenHeight+'px'
         }

         // min-height only
         if(!this.props.minHeight){
           style_obj.height = this.state.screenHeight+'px'
         };

    }
    if(this.props.style){
      style_obj = Object.assign(this.props.style,style_obj)
    }
    if(this.isMobile()){
      return(
        <div dangerouslySetInnerHTML={{__html:`<style type="text/css">
          .desktop-full-browser{
            height:${this.state.realScreenHeight}px !important;
          }
          .full-browser{
            /* Full Height Browser Fix */
            min-height:${this.state.realScreenHeight}px;
          }

          .accordion-page .accordion-link.active{
            height:${this.state.realScreenHeight}px;
            min-height:0px;
          }



          .accordion-page .accordion-link.active .header{
            min-height:${this.state.realScreenHeight}px;
            height:${this.state.realScreenHeight}px;
          }

          @media (max-width:769px) {

            .ios .accordion-page .accordion-link.active{
              height:${this.state.realScreenHeight + 10}px;
              min-height:0px;
            }

            .ios .accordion-page .accordion-link.active .header{
              min-height:${this.state.realScreenHeight+10}px;
              height:${this.state.realScreenHeight+10}px;
            }

          }

          .work-item .description,.office-page .description{
            min-height:${this.state.realScreenHeight}px;
          }


          .work-item .feature-image, .office-page .feature-image{
              min-height:${(this.state.realScreenHeight -80)}px;
          }

          @media (max-width:769px) {
              .work-item .feature-image, .office-page .feature-image{
                  min-height:100vw;
              }
          }

          .people-list .person{
            height:${this.state.realScreenHeight}px;
          }

          .video-player{
            height:${this.state.realScreenHeight}px;
          }





          .transition-holder .accordion-page .accordion-link.active .header{
            min-height:${this.state.realScreenHeight}px;
            height:${this.state.realScreenHeight}px;
            width:100%;
          }


          @media (min-aspect-ratio: 2732/1536) {
          .accordion-page .accordion-link.active .header .background img {
              width: 100vw;
            }
          }


          @media (max-aspect-ratio: 2732/1536) {
            .accordion-page .accordion-link.active .header .background img, .accordion-page .header .background img {
                height:${this.state.realScreenHeight}px;
                transition:none !important;
              }
          }

          @media (max-width: 768px) {
            .accordion-page .accordion-link:not(.active) .header .background img {
              width:100%;
              height:auto;
            }
          }
        </style>`}} />
      )
    }else{
      return null
    }
  }
}

const mapStateToProps = (state)=>{
  //console.log('state',state);


  const screenSize = state.ScreenSize.screensize

    //console.log('screenSize',screenSize);

  return {
    screenSize
  }

}

const mapDispatchToProps = (dispatch) => {


      return {
      setScreenHeight:(data)=>{
        //console.log('SET_SCREEN_SIZE',data)
        dispatch({type:'SET_SCREEN_SIZE', payload:data})
      }
    }
  }

export default connect(mapStateToProps,mapDispatchToProps)(FullBrowserHeightFix)



// WEBPACK FOOTER //
// ./src/modules/misc/FullBrowserHeightFix.js